<style scoped>
.svgContent {
  width: 100%;
  text-align: center;
}
.search-station-header {
  position: fixed;
  top: 40px;
  width: 100%;
  text-align: center;
}
.search-station-city {
  width: 400px;
  margin: 0 auto;
  padding: 5px;
  border-radius: 25px;
  color: #000;
  background-color: rgba(0, 0, 0, 0.2);
}
.search-station-city a {
  color: #fff;
}
.search-station-city a:hover {
  color: #2d8cf0;
}
.search-station-info {
  position: fixed;
  top: 40px;
  height: 95%;
  width: 350px;
  background-color: #fff;
  /* border-right: 1px solid #e8eaec; */
  box-shadow: 5px 0 5px -5px #ccc;
  overflow-y: scroll;
  scrollbar-width: none; /* FireFox */
  -ms-overflow-style: none; /*IE10+*/
}
.search-station-info::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.search-station-footer {
  position: fixed;
  bottom: 5px;
  width: 100%;
  text-align: center;
}
.search-station-footer-more {
  width: 300px;
  margin: 0 auto;
  border-radius: 25px;
  padding: 10px 5px 0 5px;
  color: #000000;
  background-color: rgba(0, 0, 0, 0.2);
}
</style>

<template>
  <div>
    <!-- 切换城市 -->
    <div v-if="searchResultGroup.length>1" class="search-station-header">
      <div class="search-station-city">
        <Row>
          <i-col span="2"><a
              @click="formatShowCityGroup(-1)"
              class="text-white"
            >
              <Icon
                size="22"
                type="md-arrow-dropleft"
              />
            </a></i-col>

          <i-col v-for="(item,index) in showSearchResultGroup"
            :key="item.cityCode" :span="(showSearchResultGroup.length === index+1)? (5 - showSearchResultGroup.length) * 5: 5"
            :class="(5 - showSearchResultGroup.length) * 5 > 5 ? 'text-left p-l-10':''"
          >
            <a
              @click="handleChangeCity(item.cityCode)"
              :class="chooseCity===item.cityCode?'active':'text-white'"
            >{{item.cityName}}({{item.quantity}})</a>
          </i-col>

          <i-col span="2"><a
              @click="formatShowCityGroup(1)"
              class="text-white"
            >
              <Icon
                size="22"
                type="md-arrow-dropright"
              />
            </a></i-col>
        </Row>
      </div>
    </div>

    <!-- 信息搜索栏，用于所见即所得 -->
    <div v-if="wysiwyg" class="search-station-info">
      <stationCondition/>
    </div>

    <!-- 站点信息展示栏 -->
    <div class="search-station-info" :style="wysiwyg? 'right:0px':'left:0px'">
      <bredcrumb-component v-if="!wysiwyg" class="p-l-20"></bredcrumb-component>
      <h2 class="text-center m-b-10">
        {{chooseStation.stationName}}
        <template v-if="!companySetting || companySetting.openFollow">
          <a
            v-if="purchaseList.find(x=>x.stationId===chooseStation.stationId)"
            class="remark  m-l-10"
            title="已关注"
            @click="handleRemovePurchase"
          >
            <Icon type="md-checkmark-circle-outline" class="text-green" size="20"/>
          <!-- <Icon type="md-star"  class="text-orange " size="20"/> -->
          </a>
          <a
            v-else
            class="m-l-10"
            title="加入关注"
            @click="handlePurchaseStation"
          >
          <!-- <Icon type="md-star-outline"  class="text-orange " size="20"/> -->
           <Icon type="md-add"  class="text-orange " size="20"/>
          <!-- <span class="text-14">加入关注</span> -->
          </a>

          <a
            v-if="historyInstall.length>0"
            style="margin-left:50px;"
            title="历史上刊"
            @click="handleShowhistoryInstall"
          >
          <Icon type="md-time"  class="text-orange " size="20"/>
          <!-- <span class="text-14">查看站内地图</span> -->
          </a>
           <a
            v-else
            style="margin-left:50px;"
            title="历史上刊"
          >
          <Icon type="md-time"  class="text-black-8f" size="20"/>
          <!-- <span class="text-14">查看站内地图</span> -->
          </a>

           <a
            v-if="stationSvgList.length>0"
            style="margin-left:10px;"
            title="站内地图"
            @click="handleShowStationSvg"
          >
          <Icon type="ios-keypad"  class="text-orange " size="20"/>
          <!-- <span class="text-14">查看站内地图</span> -->
          </a>
           <a
            v-else
            style="margin-left:10px;"
            title="站内地图"
          >
          <Icon type="ios-keypad"  class="text-black-8f" size="20"/>
          <!-- <span class="text-14">查看站内地图</span> -->
          </a>

           <a
            v-if="categorys.length>0"
            style="margin-left:10px;"
            title="联系方式"
            @click="handleShowStationProduct"
          >
          <Icon type="ios-call"  class="text-orange " size="20"/>
          <!-- <span class="text-14">查看站内地图</span> -->
          </a>
            <a
            v-else
            style="margin-left:10px;"
            title="联系方式"
          >
          <Icon type="ios-call"  class="text-black-8f" size="20"/>
          <!-- <span class="text-14">查看站内地图</span> -->
          </a>

        </template>
      </h2>

      <div class="p-l-10 p-r-10">
        <template v-if="chooseStation.companyId>0">
          <div class="text-black">
            运营商 - {{companyInfo.name}}
          </div>
        </template>

        <div class="m-t-10 text-black">
          搜索条件 - {{defaultSearchCondition.keywords}}({{businessData.length}}个)
        </div>
        <Divider style="margin:5px 0" />
        <Row :gutter="16">
          <i-col
            class="remark"
            span="12"
            v-for="(bussiness,i) in showBusinessData"
            :key="'bussiness'+i"
          >
            {{bussiness.businessName}}({{bussiness.distance}}米)
          </i-col>
        </Row>
        <p
          class="text-right"
          v-if="businessData.length>10"
        >
          <a
            v-if="showMoreBusiness"
            class="text-blue text-10"
            @click="checkBusinessData(false)"
          >收起数据
            <Icon type="ios-arrow-up" />
          </a>
          <a
            v-else
            class="text-blue text-10"
            @click="checkBusinessData(true)"
          >显示更多...</a>
        </p>

        <div class="m-t-20 text-black">交通枢纽性</div>
        <Tabs
          size="small"
          v-model="currentBusTabName"
        >
          <TabPane
            name="busStation"
            :label="'公交站台('+ busStationData.length +'个)'"
          ></TabPane>
          <TabPane
            name="busLine"
            :label="'公交线路('+ busLineData.length +'条)'"
          ></TabPane>
        </Tabs>

        <template v-if="currentBusTabName === 'busStation'">
          <Row :gutter="16">
            <i-col
              class="remark"
              span="12"
              v-for="(busStation,i) in showBusStationData"
              :key="'busStation'+i"
            >{{busStation.name}}({{busStation.value}}米)</i-col>
          </Row>
          <p
            class="text-right"
            v-if="busStationData.length>10"
          >
            <a
              v-if="showMoreBusStation"
              class="text-blue text-10"
              @click="checkBusStationData(false)"
            >收起数据
              <Icon type="ios-arrow-up" />
            </a>
            <a
              v-else
              class="text-blue text-10"
              @click="checkBusStationData(true)"
            >显示更多...</a>
          </p>
        </template>

        <template v-else>
          <Row :gutter="16">
            <i-col
              class="remark"
              span="12"
              v-for="(busLine,i) in showBusLineData"
              :key="'busLine'+i"
            >{{busLine.name}}({{busLine.value}}米)</i-col>
          </Row>
          <p
            class="text-right"
            v-if="busLineData.length>10"
          >
            <a
              v-if="showMoreBusLine"
              class="text-blue text-10"
              @click="checkBusLineData(false)"
            >收起数据
              <Icon type="ios-arrow-up" />
            </a>
            <a
              v-else
              class="text-blue text-10"
              @click="checkBusLineData(true)"
            >显示更多...</a>
          </p>
        </template>

        <div class="m-t-20 text-black">站点客流量</div>
        <template v-if="stationFlow.flowNumber>0">
          <Row :gutter="8" class="remark p-t-5">
            <i-col span="14">
              进出站月客流：{{formatNumber(stationFlow.flowNumber)}} 人
            </i-col>
            <i-col span="10" class="text-right">
              更新日期：{{stationFlow.date}}
            </i-col>
          </Row>

        </template>
        <p v-else class="text-center"><span class="remark">暂无数据</span></p>

        <template v-if="!companySetting">
          <div class="m-t-20 text-black">相似站点</div>
          <Tabs size="small" v-model="currentRecommendTabName">
            <TabPane name="local" label="本地">
              <Row :gutter="8" class="p-t-10">
                <i-col span="12" class="m-b-5" v-for="station in locationRecommendStations" :key="station.id">
                  <Icon class="m-r-5" v-if="station.union" type="md-checkmark" color="#008100" />
                  <a style="font-size: x-small;" @click="handleChangeRecommendStation(station)">{{station.assetName}} - {{station.name}}</a>
                </i-col>
              </Row>
            </TabPane>
            <TabPane name="other" label="其他城市">
              <Row :gutter="8" class="p-t-10">
                <i-col span="12" class="m-b-5" v-for="station in otherRecommendStations" :key="station.id">
                  <Icon class="m-r-5" v-if="station.union" type="md-checkmark" color="#008100" />
                  <a style="font-size: x-small;" @click="handleChangeRecommendStation(station)">{{station.assetName}} - {{station.name}}</a>
                </i-col>
              </Row>
            </TabPane>
          </Tabs>
        </template>

      </div>
    </div>

    <!-- 中间地图区域 -->
    <div v-html="svgHtml" id="svgWorkPlatform" class="svgContent"></div>
    <Spin fix v-if="spinShow">
      <Icon
        type="ios-loading"
        size=30
        class="spin-icon-load"
      ></Icon>
      <div class="text-26">地图建模中...</div>
    </Spin>

    <!-- 底部等级标注 -->
    <div class="search-station-footer">
      <Row v-if="!comprehensiveRating" class="search-station-footer-more">
        <i-col span="3">
          <img
            style="width: 20px;height: auto;"
            src="../../assets/imgs/green2.png"
          />
        </i-col>
        <i-col span="5">已关注</i-col>
        <i-col span="3">
          <img
            style="width: 20px;height: auto;"
            src="../../assets/imgs/orange2.png"
          />
        </i-col>
        <i-col span="5">未关注</i-col>
        <i-col span="3">
          <img
            style="width: 24px;height: auto;"
            src="../../assets/imgs/flicker_orange.gif"
          />
        </i-col>
        <i-col span="5">当前选中</i-col>
      </Row>
    </div>

    <shopping />
    <svgReview ref="svgReview" @on-select="handleClickResource"/>
    <historyInstall ref="historyInstall" :historyInstall="historyInstall"/>
    <product ref="product" @showonlineService = "showonlineService"/>
    <onlineService ref="onlineService"></onlineService>

  </div>
</template>

<script>
import axios from 'axios'
import shopping from './components/shopping'
import stationCondition from './components/stationCondition'
import BredcrumbComponent from '@/components/breadcrumb'
import svgReview from '@/components/svgReview'
import onlineService from '@/components/onlineService'

import historyInstall from '@/components/historyInstall'
import product from '@/components/product'

import { mapOperation } from '@/utils/mapOperation'
import { toNumber } from '@/utils/wnumb_own'

import { listBusInfos } from '@/api/dm'
import { listBusinessDetails, getRecommendStations } from '@/api/search'
import { getStationFlow } from '@/api/dw'
import { getCompanyById } from '@/api/order'
import { getStationSvgByStationId, getStationOpenStatistics } from '@/api/station'
import { getstationmaterialhistorypage } from '@/api/msp'
import { getdevicechatinfo, getcategory } from '@/api/product'

export default {
  mixins: [mapOperation], // 混入地图操作的方法
  components: {
    shopping,
    stationCondition,
    BredcrumbComponent,
    svgReview,
    historyInstall,
    product,
    onlineService
  },
  data () {
    return ({
      svgHtml: '',
      spinShow: false,
      chooseCity: '', // 默认选中城市

      businessData: [], // 原始商业数据
      showBusinessData: [], // 需要显示的商业数据
      showMoreBusiness: false,
      companyInfo: {}, // 站点所属运营商信息

      currentBusTabName: 'busStation', // 标签公交线路或者公交站点
      busStationData: [], // 原始公交站点数据
      showBusStationData: [], // 需要显示的公交站点数据
      showMoreBusStation: false,
      busLineData: [], // 公交线路数据
      showBusLineData: [], // 需要显示的公交线路数据
      showMoreBusLine: false,

      stationFlow: {}, // 站点客流数据
      searchResult: [], // 需要显示的查询结果汇总
      searchResultGroup: [], // 查询结果按城市汇总
      showSearchResultGroup: [], // 需要显示的城市汇总
      currentPage: 1,

      currentRecommendTabName: 'local', // 显示的推荐站点类别
      locationRecommendStations: [], // 本地推荐站点
      otherRecommendStations: [], // 外地推荐站点
      stationSvgList: [],

      historyInstall: [], // 站内历史上刊
      categorys: [], // 产品类目

      dasharrayIssueList: [] // 开通历程
    })
  },
  mounted () {
    this.initPageData()
    this.handleBeginSearch()
    // 设置中间区域地图高度
    this.$nextTick(() => {
      document.getElementById('svgWorkPlatform').style.height = document.documentElement.clientHeight - 40 + 'px'
    })
  },
  methods: {
    initPageData () {
      let postData = {
        stationId: this.chooseStation.stationId,
        keyword: this.defaultSearchCondition.keywords,
        quantity: 5,
        distance: this.defaultSearchCondition.distance
      }

      listBusinessDetails(postData).then(res => {
        this.businessData = res
        this.checkBusinessData(false)
      })

      if (!this.companySetting) {
        this.loadRecommendStations(postData)
      }

      listBusInfos(postData).then(res => {
        this.currentBusTabName = 'busStation'
        this.busStationData = res.filter(x => x.type === 1)
        this.checkBusStationData(false)
        this.busLineData = res.filter(x => x.type === 2)
        this.checkBusLineData(false)
      })

      getStationFlow({ stationId: this.chooseStation.stationId }).then(res => {
        this.stationFlow = res
      })

      if (this.chooseStation.companyId > 0) {
        getCompanyById({ companyId: this.chooseStation.companyId }).then(res => {
          this.companyInfo = res
        })
      }

      // 加载站内SVG地图
      getStationSvgByStationId({ stationIds: this.chooseStation.stationId }).then(res => {
        this.stationSvgList = res
      })
      // 加载站内历史上刊
      getstationmaterialhistorypage({ pageNumber: 1, pageSize: 36, stationId: this.chooseStation.stationId }).then((res) => {
        let groupCount = res.list.length / 6
        let historyGroup = []
        for (let i = 0; i < groupCount; i++) {
          historyGroup.push({
            id: i,
            historyInstall: [
              res.list[i * 6] || {},
              res.list[i * 6 + 1] || {},
              res.list[i * 6 + 2] || {},
              res.list[i * 6 + 3] || {},
              res.list[i * 6 + 4] || {},
              res.list[i * 6 + 5] || {}
            ]
          })
        }
        this.historyInstall = historyGroup
      })
      // 加载产品类目
      getcategory({ cityCode: this.chooseStation.cityCode }).then(res => {
        this.categorys = res
      })
    },
    loadRecommendStations (param) {
      this.currentRecommendTabName = 'local'
      let postData = {
        distance: param.distance,
        quantity: 10,
        stationId: this.chooseStation.stationId,
        cityCode: this.chooseStation.cityCode,
        include: 1
      }

      // 需要获取两次
      getRecommendStations(postData).then(res => {
        this.locationRecommendStations = res
      })

      postData.include = 0
      getRecommendStations(postData).then(res => {
        this.otherRecommendStations = res
      })
    },
    checkBusinessData (isShow) {
      this.showMoreBusiness = isShow

      if (this.showMoreBusiness) {
        this.showBusinessData = this.businessData
      } else {
        this.showBusinessData = this.businessData.length > 0 ? this.businessData.slice(0, 10) : []
      }
    },
    checkBusStationData (isShow) {
      this.showMoreBusStation = isShow

      if (this.showMoreBusStation) {
        this.showBusStationData = this.busStationData
      } else {
        this.showBusStationData = this.busStationData.slice(0, 10)
      }
    },
    checkBusLineData (isShow) {
      this.showMoreBusLine = isShow

      if (this.showMoreBusLine) {
        this.showBusLineData = this.busLineData
      } else {
        this.showBusLineData = this.busLineData.slice(0, 10)
      }
    },
    handleBeginSearch () { // 先获取查询条件的城市分组
      this.spinShow = true

      axios.post(process.env.API_URL + '/ooh-search/v1/search/getcityquantity',
        this.defaultSearchCondition,
        {
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: false
        }
      ).then(res => {
        this.searchResultGroup = res.data
        // 获取当前城市所在的页码， 然后自动显示
        let cityIndex = this.searchResultGroup.findIndex(x => x.cityCode === this.chooseStation.cityCode)
        this.currentPage = parseInt(cityIndex / 4)
        this.formatShowCityGroup(1)
        this.handleChangeCity(this.chooseStation.cityCode)
      })
    },
    formatShowCityGroup (page) {
      this.currentPage += page
      this.showSearchResultGroup = []
      let start = (this.currentPage - 1) * 4

      // 翻到尽头，重新回到第一页
      if (start > this.searchResultGroup.length) {
        this.currentPage = 1
        start = 0
      }
      // 回到到没有， 那么到最后一页
      if (start < 0) {
        this.currentPage = parseInt(this.searchResultGroup.length / 4) + 1
        start = (this.currentPage - 1) * 4
      }

      for (let index = start; index < this.currentPage * 4; index++) {
        if (index >= this.searchResultGroup.length) { break }

        this.showSearchResultGroup.push(this.searchResultGroup[index])
      }
    },
    loadMapData () {
      const mapSearch = Object.assign({}, this.defaultSearchCondition,
        { pageNumber: 1,
          pageSize: 1000,
          cityCodes: [this.chooseCity]
        })

      axios.post(process.env.API_URL + '/ooh-search/v1/search/getsearchresultpage',
        mapSearch,
        {
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: false
        }
      ).then(res => {
        this.searchResult = res.data.list
        let assetList = []
        let stationList = []

        this.searchResult.forEach(element => {
          if (!assetList.includes(element.assetId)) {
            assetList.push(element.assetId)
          }

          if (!stationList.includes(element.stationId)) {
            stationList.push({
              stationId: element.stationId.toString(),
              inPurchase: this.purchaseList.find(x => x.stationId === element.stationId) !== undefined,
              level: element.rank
            })
          }
        })

        // 如果当前城市内没有选中站点，那么自动选择第一个
        if (stationList.find(x => x.stationId === this.chooseStation.stationId.toString())) {
          this.fillLineGray(assetList, stationList, this.chooseStation.stationId.toString(), this.comprehensiveRating ? this.defaultSearchCondition.dynamicLevel : 0, this.dasharrayIssueList)
        } else {
          this.handleClickStation(stationList[0].stationId, stationList[0])
        }
      })
    },
    handleChangeCity (cityCode) {
      this.chooseCity = cityCode
      this.initMap()
      // 载入线路开通历程
      getStationOpenStatistics({ cityCode: this.chooseCity }).then(res => {
        this.dasharrayIssueList = [] // 暂未开通的issue
        res.forEach(element => {
          if (new Date(element.openDate) > new Date()) {
            this.dasharrayIssueList.push(element)
          }
        })
      })
    },
    handleClickStation (stationId, station) {
      // 从查询结果中找到该对象， 并复制
      let currentStation
      // 如果是换乘站, 验证是否包含在显示线路目录中
      stationId.split(',').forEach(id => {
        if (!currentStation) {
          currentStation = this.searchResult.find(x => x.stationId === parseInt(id))
        }
      })

      // 从查询结果中找到该对象， 并复制
      if (!currentStation) {
        currentStation = {
          assetId: station.assetId,
          assetName: station.assetName,
          cityCode: station.cityCode,
          cityName: station.cityName,
          companyId: station.companyId,
          stationId: station.id,
          stationName: station.name,
          rank: 0
        }
      }

      this.$store.commit('set_search_chooseStation', currentStation)
      this.loadMapData()
      this.initPageData()
    },
    handleClickCurrentStation (stationId) {
      this.handleShowStationSvg()
    },
    formatNumber (num) {
      return toNumber(num)
    },
    handlePurchaseStation () {
      let updateBean = {
        type: 'add',
        item: this.chooseStation
      }

      this.$store.commit('set_search_updatePurchase', updateBean)
    },
    handleRemovePurchase () { // 移除选中
      let updateBean = {
        type: 'remove',
        item: this.chooseStation
      }

      this.$store.commit('set_search_updatePurchase', updateBean)
    },
    handleChangeRecommendStation (station) {
      if (station.cityCode !== this.chooseCity) {
        this.handleChangeCity(station.cityCode)
      }

      this.handleClickStation(station.id.toString(), station)
    },
    handleShowStationSvg () {
      let showTitle = this.chooseStation.assetName
      showTitle += ' - '
      showTitle += this.chooseStation.stationName
      showTitle += ' - 站内地图'

      this.$refs.svgReview.beginReviewSvg(this.stationSvgList, showTitle)
    },
    handleShowhistoryInstall () {
      let showTitle = this.chooseStation.assetName
      showTitle += ' - '
      showTitle += this.chooseStation.stationName
      showTitle += ' - 历史上刊画面'

      this.$refs.historyInstall.showhistory(showTitle)
    },
    handleShowStationProduct () {
      this.$refs.product.showModel(this.categorys, this.chooseStation.cityCode)
    },
    showonlineService (data) {
      this.$refs.onlineService.showModal(data)
    },
    handleClickResource (deviceId) {
      const that = this
      getdevicechatinfo({ deviceId: deviceId }).then(res => {
        let data = {
          resourceName: res.code,
          linkuserName: res.imUsername,
          stationName: res.stationName,
          assetNames: res.assetName,
          operator: res.operator
        }
        that.$refs.onlineService.showModal(data)
      })
    }
  },
  computed: {
    companySetting () {
      return this.$store.state.user.companySetting
    },
    chooseStation () {
      return this.$store.state.search.chooseStation
    },
    defaultSearchCondition () {
      return this.$store.state.search.searchCondition
    },
    purchaseList () {
      return this.$store.state.search.purchaseList
    },
    wysiwyg () { // 所见即所得，显示左侧查询栏
      return this.companySetting ? this.companySetting.wysiwyg : null
    },
    beginSearch () {
      return this.$store.state.search.beginSearch
    },
    filterData () {
      return this.$store.state.search.filterData
    },
    comprehensiveRating () { // 综合定级
      return this.companySetting ? this.companySetting.comprehensiveRating : null
    }
  },
  watch: {
    beginSearch (val) {
      this.handleBeginSearch()
    },
    spinShow (val) {
      if (!val) {
        this.loadMapData()
      }
    },
    filterData () {
      // this.handleChangeDimensionRang()
      // this.groupSearchResult()
      // this.loadMapData()
    }
  }
}
</script>
